(() => {
  const splash = document.querySelector('[data-mahawa-page-splash]');
  if (!splash || splash.dataset.initialized === 'true') return;

  splash.dataset.initialized = 'true';

  const oncePerSession = splash.dataset.oncePerSession === 'true';
  const minimumDuration = Number.parseInt(splash.dataset.minimumDuration || '800', 10);
  const maximumDuration = Number.parseInt(splash.dataset.maximumDuration || '1500', 10);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sessionKey = 'mahawa-page-splash-seen-v3';
  const startedAt = performance.now();
  let dismissed = false;
  let alreadySeen = false;

  try {
    alreadySeen = window.sessionStorage.getItem(sessionKey) === '1';
  } catch (error) {}

  const removeSplash = () => {
    if (dismissed) return;
    dismissed = true;

    try {
      if (oncePerSession) window.sessionStorage.setItem(sessionKey, '1');
    } catch (error) {}

    splash.classList.add('is-leaving');
    document.documentElement.classList.remove('mahawa-splash-pending');
    window.setTimeout(() => splash.remove(), 240);
  };

  const dismissAfterMinimum = () => {
    const elapsed = performance.now() - startedAt;
    window.setTimeout(removeSplash, Math.max(0, minimumDuration - elapsed));
  };

  if (reducedMotion || (oncePerSession && alreadySeen)) {
    document.documentElement.classList.remove('mahawa-splash-pending');
    splash.remove();
    return;
  }

  if (document.readyState === 'complete') {
    dismissAfterMinimum();
  } else {
    window.addEventListener('load', dismissAfterMinimum, { once: true });
  }

  window.setTimeout(removeSplash, maximumDuration);
})();
